import {
	ContextMenu,
	DataList,
	Skeleton,
	TableFilter,
} from '@welbe/web-design-system';
import { ModalCommunication } from '../Communications/components/ModalCommunication/ModalCommunication';
import { AddReminder } from '../shared/AddReminder/AddReminder';
import { formattedColumns, formattedRows } from './Builder';
import { useCollaborators } from './Collaborators.hooks';
import {
	Container,
	ContainerInfo,
	ContainerTitle,
	Description,
	FooterContainer,
	Info,
	LayoutPage,
	ReferAmount,
	ReferContainer,
	Title,
	Wrapper,
} from './Collaborators.styles';
import { CollaboratorFilters } from './components/CollaboratorFilters/CollaboratorFilters';
import { CollaboratorDetails } from './components/CollaboratorInfo/CollaboratorDetails';
import { CollaboratorsPercentual } from './components/CollaboratorsPercentual/CollaboratorsPercentual';
import { ContextInput } from './components/ContextInput/ContextInput';
import { ContextMenuItem } from './components/ContextMenuItem/ContextMenuItem';
import { ReferModalFlow } from './ReferModalFlow/ReferModalFlow';
import { Button } from '@welbe/design-system';

export const Collaborators = () => {
	const {
		amount,
		campaignId,
		isReferVisible,
		isLoadingCommunication,
		selectedCommunication,
		communications,
		employeeDetails,
		setCommunication,
		setEmployeeDetails,
		handleCloseReferModal,
		handleRefer,
		handleSelectCommunication,
		selectedEmployees,
		setSelectedEmployees,
		isCommunicationOpen,
		pickerSelected,
		communicationCreatedTypes,
		reminderOption,
		height,
		isFilterOpen,
		setFilterOpen,
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		handleChangePageSize,
		handleSelectEmployees,
		handleOpenEmployeeDetail,
		filters,
	} = useCollaborators();

	return (
		<>
			{employeeDetails.visible ? (
				<CollaboratorDetails
					campaignId={campaignId}
					employeeId={employeeDetails.employeeId}
					campaignAnswerId={employeeDetails.campaignAnswerId}
					onBackScreen={() =>
						setEmployeeDetails({
							visible: false,
							employeeId: '',
							campaignAnswerId: '',
						})
					}
				/>
			) : (
				<Wrapper>
					<ContainerTitle>
						<ContextMenu
							customElementAction={
								<ContextInput
									reference={selectedCommunication}
									loading={isLoadingCommunication}
									isOpen={true}
								/>
							}
							options={communications.map((item, index) => (
								<ContextMenuItem key={index}>
									<Description variant>{item.technicalName}</Description>
									<Description>{item.name}</Description>
								</ContextMenuItem>
							))}
							childrenHeight="60px"
							onChange={(item) => handleSelectCommunication(Number(item.key))}
						/>
					</ContainerTitle>

					<ContainerInfo>
						<Info>
							{selectedCommunication?.name &&
							selectedCommunication?.technicalName ? (
								<>
									<Title>{selectedCommunication?.name || ''}</Title>
									<Title variant>
										Consulta la lista de colaboradores, no olvides referir a
										quienes requieran atención.
									</Title>
								</>
							) : (
								<>
									<Skeleton width="250px" height="23px" />
									<Skeleton width="90%" height="46px" />
								</>
							)}
						</Info>
						<CollaboratorsPercentual
							campaignId={campaignId}
							onRefer={handleRefer}
							sequence={selectedCommunication?.sequence}
							questionnaireId={selectedCommunication?.id || ''}
						/>
					</ContainerInfo>

					<Container>
						<TableFilter
							open={isFilterOpen}
							height={height - 135}
							onSearch={handleSearch}
							filters={filters}
							onClose={() => setFilterOpen(false)}
							onOpen={() => setFilterOpen(true)}
						>
							<CollaboratorFilters
								loading={loading}
								sequence={selectedCommunication?.sequence ?? 0}
								height={height - 210}
								onChangeFilters={handleFilters}
								onSearch={handleSearch}
							/>
						</TableFilter>
						<LayoutPage>
							<DataList
								onSelect={handleSelectEmployees}
								selected={selectedEmployees}
								loading={loading}
								headers={formattedColumns(selectedCommunication?.sequence)}
								currentPage={currentPage}
								pagesNumber={totalPages}
								pageSize={filters.pageSize}
								onChangePage={handleChangePage}
								onChangePageSize={handleChangePageSize}
								rows={formattedRows(
									data,
									selectedCommunication?.sequence,
									handleOpenEmployeeDetail,
								)}
								height={`${height - 300}px`}
							/>
						</LayoutPage>
					</Container>

					<FooterContainer>
						<AddReminder
							buttonText="Enviar recordatorio"
							variation="outline"
							text="Colaboradores sin respuesta"
							buttonWidth="200px"
							justify="flex-start"
							onConfirm={() => setCommunication(true)}
						/>
						{selectedCommunication?.sequence === 0 && (
							<ReferContainer>
								<ReferAmount>
									Total selecionados: {selectedEmployees.length}
								</ReferAmount>
								<Button
									disabled={!selectedEmployees.length}
									onClick={() => handleRefer('table', selectedEmployees)}
								>
									Referir
								</Button>
							</ReferContainer>
						)}
					</FooterContainer>

					<ReferModalFlow
						isReferVisible={isReferVisible}
						selectedEmployees={selectedEmployees}
						setSelectedEmployees={setSelectedEmployees}
						onCloseReferFlow={handleCloseReferModal}
						amount={amount}
						selectedCommunication={selectedCommunication}
						onRetryTable={() => setSelectedEmployees([])}
					/>

					<ModalCommunication
						visible={isCommunicationOpen}
						campaign={{ id: campaignId, name: '', communications: [] }}
						onClose={() => setCommunication(false)}
						communicationCreatedDates={pickerSelected || []}
						communicationCreatedTypes={communicationCreatedTypes}
						initialCommunicationType={reminderOption}
						optionsCommunicationType={[reminderOption]}
					/>
				</Wrapper>
			)}
		</>
	);
};
